module.exports = __webpack_public_path__ + "img/g.e9d6aea6.jpg";